module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/lion-portuguese.5d05bd1e.jpg";